import React from 'react';

type StatusVariant =
  | 'online' | 'offline' | 'degraded' | 'maintenance' | 'decommissioned'
  | 'allocated' | 'available' | 'reserved' | 'conflicted'
  | 'static' | 'dhcp' | 'warning' | 'info'
  | 'assegnato' | 'disponibile' | 'conflitto' | 'riservato' | 'statico';

interface StatusBadgeProps {
  status: StatusVariant;
  label?: string;
  size?: 'sm' | 'md';
}

const statusConfig: Record<StatusVariant, { label: string; className: string; dot: string }> = {
  online:         { label: 'Online',        className: 'bg-green-500/15 text-green-400 border border-green-500/20',  dot: 'bg-green-400 pulse-online' },
  offline:        { label: 'Offline',       className: 'bg-red-500/15 text-red-400 border border-red-500/20',        dot: 'bg-red-400' },
  degraded:       { label: 'Degraded',      className: 'bg-amber-500/15 text-amber-400 border border-amber-500/20',  dot: 'bg-amber-400' },
  maintenance:    { label: 'Maintenance',   className: 'bg-blue-500/15 text-blue-400 border border-blue-500/20',     dot: 'bg-blue-400' },
  decommissioned: { label: 'Decommissioned',className: 'bg-zinc-500/15 text-zinc-400 border border-zinc-500/20',    dot: 'bg-zinc-400' },
  allocated:      { label: 'Allocated',     className: 'bg-sky-500/15 text-sky-400 border border-sky-500/20',        dot: 'bg-sky-400' },
  available:      { label: 'Available',     className: 'bg-green-500/15 text-green-400 border border-green-500/20', dot: 'bg-green-400' },
  reserved:       { label: 'Reserved',      className: 'bg-purple-500/15 text-purple-400 border border-purple-500/20', dot: 'bg-purple-400' },
  conflicted:     { label: 'Conflicted',    className: 'bg-red-500/15 text-red-400 border border-red-500/20',        dot: 'bg-red-400' },
  static:         { label: 'Static',        className: 'bg-indigo-500/15 text-indigo-400 border border-indigo-500/20', dot: 'bg-indigo-400' },
  dhcp:           { label: 'DHCP',          className: 'bg-cyan-500/15 text-cyan-400 border border-cyan-500/20',    dot: 'bg-cyan-400' },
  warning:        { label: 'Warning',       className: 'bg-amber-500/15 text-amber-400 border border-amber-500/20', dot: 'bg-amber-400' },
  info:           { label: 'Info',          className: 'bg-sky-500/15 text-sky-400 border border-sky-500/20',        dot: 'bg-sky-400' },
  assegnato:      { label: 'Assegnato',    className: 'bg-sky-500/15 text-sky-400 border border-sky-500/20',        dot: 'bg-sky-400' },
  disponibile:    { label: 'Disponibile',  className: 'bg-green-500/15 text-green-400 border border-green-500/20', dot: 'bg-green-400' },
  conflitto:      { label: 'Conflitto',    className: 'bg-red-500/15 text-red-400 border border-red-500/20',        dot: 'bg-red-400' },
  riservato:      { label: 'Riservato',    className: 'bg-purple-500/15 text-purple-400 border border-purple-500/20', dot: 'bg-purple-400' },
  statico:        { label: 'Statico',      className: 'bg-indigo-500/15 text-indigo-400 border border-indigo-500/20', dot: 'bg-indigo-400' },
};

export default function StatusBadge({ status, label, size = 'sm' }: StatusBadgeProps) {
  const config = statusConfig[status] || statusConfig['info'];
  const displayLabel = label || config.label;
  const sizeClass = size === 'md' ? 'px-2.5 py-1 text-xs' : 'px-2 py-0.5 text-xs';

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-medium ${sizeClass} ${config.className}`}>
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${config.dot}`} />
      {displayLabel}
    </span>
  );
}